import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { PageID } from '../../../components/ReferenceBar/HelpDrawer/types.ts';

const pathEndingToPageID: Record<string, PageID> = {
  'paired-cost/properties': 'properties',
  'paired-cost/cost-details': 'replacement-cost',
  'paired-cost/summary': 'summary',
  'paired-cost/adjustments-summary': 'adjustments-summary',
  'paired-cost/commentary-summary': 'commentary-summary',
  'paired-cost/cost-appr-summary': 'cost-appr-summary',
  studies: 'paired-sales-library',
  'paired-cost/analysis': 'analysis',
  'paired-cost/adjustments': 'adjustments',
  'paired-cost/commentary': 'commentary',
  'paired-cost/craftsman-cost-approach': 'craftsman-cost-approach',
  qc: 'qc',

  'paired-cost/features': 'features',
  'paired-cost/market': 'market-conditions',
  'paired-cost/cost-approach': 'appraisify-cost-approach',
  'paired-cost/adjustments-grid': 'sale-comparison',
  'paired-cost/appraisify-commentary': 'appraisify-commentary',
  'paired-cost/reconciliation': 'reconciliation',
};

/** Gets the Contentful document page ID for the current route. */
export const useHelpDrawerPageID = (): { pageID: PageID | null } => {
  const { pathname, search } = useLocation();

  const pageID: PageID | null = useMemo(() => {
    const match = Object.entries(pathEndingToPageID).find(([pathEnding]) =>
      pathname.endsWith(pathEnding),
    )?.[1];

    if (match === 'features' && search.includes('addComps=true')) {
      return 'recommended-comps';
    }

    if (match) return match;

    // HACK: The search and adjust parts of paired sales are in the same route.
    // Instead of adding a subrouter, we check if we're in any part of the paired
    // sales process. Unfortunately, this means that the help drawer will only show
    // one document for the entire paired sales flow.
    if (pathname.includes('paired-sales')) {
      return 'paired-sales-search-and-adjust';
    }

    return null;
  }, [pathname, search]);

  return { pageID };
};
